module.exports = __webpack_public_path__ + "static/media/spot13.42630125.webp";